<template>
	<div id="app">
		<div v-scroll-stop="hasPopup || openModalName !== ''" :class="stateHeader === CONST.HEADER_STATE.NONE ? 'full-view' : ''">
			<div class="layout-sidemenu" :class="openLeftMenu ? 'is-open' : ''">
				<AppSideLeft />
			</div>
			<div class="layout-content" :class="openLeftMenu ? 'has-menu' : ''">
				<app-header-main v-if="stateHeader !== CONST.HEADER_STATE.NONE" />
				<div class="app-body color-bgGray-bg" :class="stateHeader === CONST.HEADER_STATE.NONE ? 'pa-0' : ''">
					<router-view :loginMember="loginMember"></router-view>
				</div>
				<Footer v-if="stateHeader !== CONST.HEADER_STATE.NONE" />
			</div>
			<div class="axios-loading" v-if="isLoading">
				<div class="loader"></div>
			</div>
			<!--			<app-footer v-if="isFooter" :class="this.isFooterMargin" />-->
		</div>

		<!--		<AppSideRightFirst :open="openRightFirst" />-->
		<!--		<AppSideRight :open="openRight" />-->

		<!-- 사업비관리 동의서 -->
		<modal-famppy v-if="openModalName === 'modalAgree'" :class="'modalAgree'" v-on:close.prevent.stop="openModalName = ''">
			<template v-slot:header>
				<h3>{{ openModalTitle }}</h3>
				<div class="close-btn" name="closeBtn" v-on:click.prevent.stop="closeThenRefresh">
					<img class="icon-trash" :src="require('./assets/images/icon/icon-close@2x.png')" />
				</div>
			</template>
			<template v-slot:body>
				<PopupAgreement class="" :modalParam="modalParam" />
			</template>
			<template v-slot:footer>
				<div class="btn-area">
					<button
						class="greenBtn"
						:class="modalParam.userSubmitState === 'DONE' ? '' : 'big'"
						@click.prevent.stop="openAgreementPrev"
						v-if="!isCompany"
					>
						{{ modalParam.userSubmitState === 'DONE' ? '동의서 보기' : '동의 및 동의서 보기' }}
					</button>
					<button class="greenBtn" @click.prevent.stop="openAgreementPrev" v-if="isCompany">
						동의서 보기
					</button>
				</div>
			</template>
		</modal-famppy>

		<!-- 사업계획서 팝업-->
		<modal-famppy v-if="openModalName === 'modalPlan'" v-on:close.prevent.stop="openModalName = ''">
			<template v-slot:header>
				<h3>{{ openModalTitle }}</h3>
				<div class="close-btn" name="closeBtn" v-on:click.prevent.stop="closeThenRefresh">
					<img class="icon-trash" :src="require('./assets/images/icon/icon-close@2x.png')" />
				</div>
			</template>
			<template v-slot:body>
				<PopupPlan class="" :modalParam="modalParam" />
			</template>
			<template v-slot:footer>
				<div class="btn-area">
					<button class="grayBtn" v-if="!isCompany" v-on:click.prevent.stop="openModalName = ''">
						취소
					</button>
					<button class="greenBtn" v-if="!isCompany" @click.prevent.stop="() => eventBus.$emit(CONST.EVENTS.SAVE_MODAL, openModalName, 'SAVE')">
						저장
					</button>
				</div>
			</template>
		</modal-famppy>

		<!-- 주소록 팝업-->
		<modal-famppy v-if="openModalName === 'modalAddress'" v-on:close.prevent.stop="openModalName = ''">
			<template v-slot:header>
				<h3>{{ openModalTitle }}</h3>
				<div class="close-btn" name="closeBtn" v-on:click.prevent.stop="openModalName = ''">
					<img class="icon-trash" :src="require('./assets/images/icon/icon-close@2x.png')" />
				</div>
			</template>
			<template v-slot:body>
				<PopupAddress class="" />
			</template>
			<template v-slot:footer>
				<div class="btn-area">
					<!--					<button class="pinkBtn" @click="choiceReceiveUser()">-->
					<!--						확인-->
					<!--					</button>-->
				</div>
			</template>
		</modal-famppy>

		<!-- 바이어 보고서 팝업-->
		<modal-famppy v-if="openModalName === 'modalBuyer'" v-on:close.prevent.stop="openModalName = ''">
			<template v-slot:header>
				<!--				<h3>{{ openModalTitle }}</h3>-->
				<div class="close-btn" name="closeBtn" v-on:click.prevent.stop="closeBuyer">
					<img class="icon-trash" :src="require('./assets/images/icon/icon-close@2x.png')" />
				</div>
			</template>
			<template v-slot:body>
				<PopupBuyer class="" :modalParam="modalParam" />
			</template>
			<template v-slot:footer> </template>
		</modal-famppy>

		<!--    민원팝업-->
		<modal-famppy v-if="openModalName === 'modalComplain'" v-on:close.prevent.stop="openModalName = ''" class="off-footer">
			<template v-slot:header>
				<h3>{{ openModalTitle }}</h3>
				<div class="close-btn" name="closeBtn" v-on:click.prevent.stop="openModalName = ''">
					<img class="icon-trash" :src="require('./assets/images/icon/icon-close@2x.png')" />
				</div>
			</template>
			<template v-slot:body>
				<PopupComplain :matchSeqNo="matchSeqNo" />
			</template>
			<template v-slot:footer> </template>
		</modal-famppy>

		<!-- 메인 프로그램보고서 팝업 -->
		<modal-famppy v-if="openModalName === 'modalMainProgramReport'" v-on:close.prevent.stop="openModalName = ''">
			<template v-slot:header>
				<h3>{{ openModalTitle }}</h3>
				<div class="close-btn" name="closeBtn" v-on:click.prevent.stop="openModalName = ''">
					<img class="icon-trash" :src="require('./assets/images/icon/icon-close@2x.png')" />
				</div>
			</template>
			<template v-slot:body>
				<PopupMainProgramReport :modalParam="modalParam" />
			</template>
			<template v-slot:footer>
				<div class="btn-area">
					<button class="grayBtn" v-if="!isCompany" v-on:click.prevent.stop="openModalName = ''">
						취소
					</button>
					<button class="greenBtn" v-if="!isCompany" @click.prevent.stop="() => eventBus.$emit(CONST.EVENTS.SAVE_MODAL, openModalName, 'SAVE')">
						저장
					</button>
				</div>
			</template>
		</modal-famppy>

		<!-- 메인 최종보고서 팝업 -->
		<modal-famppy v-if="openModalName === 'modalMainFinalReport'" v-on:close.prevent.stop="openModalName = ''">
			<template v-slot:header>
				<h3>{{ openModalTitle }}</h3>
				<div class="close-btn" name="closeBtn" v-on:click.prevent.stop="openModalName = ''">
					<img class="icon-trash" :src="require('./assets/images/icon/icon-close@2x.png')" />
				</div>
			</template>
			<template v-slot:body>
				<PopupMainFinalReport :modalParam="modalParam" />
			</template>
			<template v-slot:footer>
				<div class="btn-area">
					<button class="grayBtn" v-if="!isCompany" v-on:click.prevent.stop="openModalName = ''">
						취소
					</button>
					<button class="greenBtn" v-if="!isCompany" @click.prevent.stop="() => eventBus.$emit(CONST.EVENTS.SAVE_MODAL, openModalName, 'SAVE')">
						저장
					</button>
				</div>
			</template>
		</modal-famppy>

		<!-- 메인 월별보고서 팝업 -->
		<modal-famppy v-if="openModalName === 'modalMainMonthlyReport'" v-on:close.prevent.stop="openModalName = ''">
			<template v-slot:header>
				<h3>{{ openModalTitle }}</h3>
				<div class="close-btn" name="closeBtn" v-on:click.prevent.stop="openModalName = ''">
					<img class="icon-trash" :src="require('./assets/images/icon/icon-close@2x.png')" />
				</div>
			</template>
			<template v-slot:body>
				<PopupMainMonthlyReport :modalParam="modalParam" />
			</template>
			<template v-slot:footer>
				<div class="btn-area">
					<button class="grayBtn" v-if="!isCompany" v-on:click.prevent.stop="openModalName = ''">
						취소
					</button>
					<button class="greenBtn" v-if="!isCompany" @click.prevent.stop="() => eventBus.$emit(CONST.EVENTS.SAVE_MODAL, openModalName, 'SAVE')">
						저장
					</button>
				</div>
			</template>
		</modal-famppy>

		<!--

		&lt;!&ndash;    미동의 사유 작성&ndash;&gt;
		<modal-famppy
			v-if="openModalName === 'unacceptModal' || openModalName === 'agreeNoticeModal' || openModalName === 'visitNoticeModal'"
			v-on:close.prevent.stop="openModalName = ''"
			:class="'modalAgree'"
		>
			<template v-slot:header>
				<h3>{{ openModalTitle }}</h3>
				<div class="close-btn" @click="closeNoticeModal(openModalName)">
					<img class="icon-trash" :src="require('./assets/images/icon/icon-close@2x.png')" />
				</div>
			</template>
			<template v-slot:body>
				<PopupUnaccept :modalParam="modalParam" :openModalName="openModalName" />
			</template>
			<template v-slot:footer>
				<div class="btn-area">
					<button
						class="pinkBtn"
						@click.prevent.stop="() => eventBus.$emit(CONST.EVENTS.SAVE_MODAL, openModalName, modalParam)"
						v-if="openModalName === 'unacceptModal'"
					>
						저장
					</button>
				</div>
			</template>
		</modal-famppy>
-->

		<!--		&lt;!&ndash;    미동의 사유 노출&ndash;&gt;-->
		<!--		<modal-famppy v-if="openModalName === 'noticeModal'" v-on:close.prevent.stop="openModalName = ''">-->
		<!--			<template v-slot:header>-->
		<!--				<h3>미동의 사유</h3>-->
		<!--				<div class="close-btn" v-on:click.prevent.stop="openModalName = ''">-->
		<!--					<img class="icon-trash" :src="require('./assets/images/icon/icon-close@2x.png')" />-->
		<!--				</div>-->
		<!--			</template>-->
		<!--			<template v-slot:body>-->
		<!--				<PopupUnaccept :modalParam="modalParam" />-->
		<!--			</template>-->
		<!--			<template v-slot:footer>-->
		<!--				<div class="btn-area">-->
		<!--					&lt;!&ndash;					<button class="pinkBtn" @click.prevent.stop="() => eventBus.$emit(CONST.EVENTS.SAVE_MODAL, openModalName, modalParam)">&ndash;&gt;-->
		<!--					&lt;!&ndash;						저장&ndash;&gt;-->
		<!--					&lt;!&ndash;					</button>&ndash;&gt;-->
		<!--				</div>-->
		<!--			</template>-->
		<!--		</modal-famppy>-->

		<!--		&lt;!&ndash;    마케터 계좌추가&ndash;&gt;
		<modal-famppy v-if="openModalName === 'modalMarketerAccount'" v-on:close.prevent.stop="openModalName = ''">
			<template v-slot:header>
				<h3>{{ openModalTitle }}</h3>
				<div class="close-btn" v-on:click.prevent.stop="openModalName = ''">
					<img class="icon-trash" :src="require('./assets/images/icon/icon-close@2x.png')" />
				</div>
			</template>
			<template v-slot:body>
				<PopupAccountAdd />
			</template>
			<template v-slot:footer>
				<div class="btn-area">
					<button class="cursor grayBtn" @click.prevent.stop="openModalName = ''">취소</button>
					<button class="pinkBtn" @click.prevent.stop="() => eventBus.$emit(CONST.EVENTS.SAVE_MODAL, openModalName)">저장</button>
				</div>
			</template>
		</modal-famppy>-->

		<form ref="kcpAuthForm" method="post" accept-charset="euc-kr">
			<input type="hidden" name="param_opt" v-model="token" />
			<input type="hidden" name="param_opt_2" v-model="matchSeqNo" />
		</form>
	</div>
</template>

<script>
import eventBus from '@/plugins/event-bus';
import AppHeaderMain from '@/components/common/AppHeaderMain';
import AppSideLeft from '@/components/common/AppSideLeft';
import CONST from '@/constants';
import Footer from '@/components/common/AppFooter';
import ModalFamppy from '@/components/common/ModalFamppy';
import PopupComplain from '@/components/popup/PopupComplain';
import PopupUnaccept from '@/components/popup/PopupUnaccept';
import PopupAgreement from '@/components/popup/PopupAgreement';
import PopupPlan from '@/components/popup/PopupPlan';
import PopupAddress from '@/components/popup/PopupAddress';
import PopupBuyer from '@/components/popup/PopupBuyer';
import PopupMainProgramReport from '@/components/popup/PopupMainProgramReport';
import PopupMainFinalReport from '@/components/popup/PopupMainFinalReport';
import PopupMainMonthlyReport from '@/components/popup/PopupMainMonthlyReport';

export default {
	name: 'App',
	components: {
		PopupComplain,
		PopupPlan,
		PopupAgreement,
		ModalFamppy,
		Footer,
		AppHeaderMain,
		AppSideLeft,
		PopupAddress,
		PopupBuyer,
		PopupMainProgramReport,
		PopupMainFinalReport,
		PopupMainMonthlyReport,
	},
	data: function() {
		return {
			PopupUnaccept: PopupUnaccept,
			PopupAgreement: PopupAgreement,
			PopupPlan: PopupPlan,
			PopupAddress: PopupAddress,
			PopupBuyer: PopupBuyer,
			PopupComplain: PopupComplain,
			ModalFamppy: ModalFamppy,
			eventBus,
			isLoading: false,
			hasPopup: false,
			openLeftMenu: false,
			stateHeader: CONST.HEADER_STATE.MAIN,
			loginMember: null,
			CONST,
			openModalName: '',
			openModalTitle: '',
			modalParam: '',
			token: '',
			checkInt: null,
			matchSeqNo: 0,
		};
	},
	computed: {
		isSingleHeader() {
			return this.stateHeader === CONST.HEADER_STATE.MAIN;
		},
		isCompany() {
			return this.loginMember && this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY;
		},
	},
	created: function() {
		this.isMain = false;
		eventBus.$on(
			CONST.EVENTS.LOGIN_COMPLETE,
			function() {
				this.loadMemberInfo();
			}.bind(this),
		);
		eventBus.$on(
			CONST.EVENTS.LOGOUT_COMPLETE,
			function() {
				this.loadMemberInfo();
				window.location.reload();
			}.bind(this),
		);
		eventBus.$on(
			CONST.EVENTS.DATA_LOADING,
			function() {
				this.isLoading = true;
			}.bind(this),
		);
		eventBus.$on(
			CONST.EVENTS.DATA_LOADED,
			function() {
				this.isLoading = false;
			}.bind(this),
		);
		eventBus.$on(
			CONST.EVENTS.SET_HEADER_STATE,
			function(v) {
				this.stateHeader = v;
			}.bind(this),
		);
		eventBus.$on(
			CONST.EVENTS.OPEN_SIDE_MENU,
			function() {
				this.openLeftMenu = !this.openLeftMenu;
			}.bind(this),
		);
		eventBus.$on(
			CONST.EVENTS.CLOSE_SIDE_MENU,
			function() {
				this.openLeftMenu = false;
			}.bind(this),
		);
		eventBus.$on(
			CONST.EVENTS.HIDE_FOOTER_MENU,
			function(v) {
				this.isFooter = !v;
			}.bind(this),
		);
		eventBus.$on(
			CONST.EVENTS.HAS_POPUP,
			function(v) {
				this.hasPopup = v;
			}.bind(this),
		);
		eventBus.$on(
			CONST.EVENTS.OPEN_MODAL,
			function(v, t, param) {
				this.openModalName = v;
				this.openModalTitle = t || '';
				if (typeof param !== 'undefined') {
					this.modalParam = param;
					this.matchSeqNo = this.modalParam.matchSeqNo;
				}
			}.bind(this),
		);
		eventBus.$on(
			CONST.EVENTS.CLOSE_MODAL,
			function() {
				this.openModalName = '';
			}.bind(this),
		);
		eventBus.$on(
			CONST.EVENTS.CLOSE_MODAL_REFRESH,
			function() {
				this.closeThenRefresh();
			}.bind(this),
		);
		let token = this.$device.loadLocalData('LOGIN_TOKEN');
		if (token) this.$apiClient.setApiToken(token);
		this.loadMemberInfo();
	},
	mounted: function() {
		this.token = this.$apiClient.getApiToken();
		this.loadMemberInfo();
	},
	methods: {
		doWindowAlert: function(msg) {
			window.alert(msg);
		},
		closeThenRefresh: function() {
			this.openModalName = '';
			window.location.reload();
		},
		closeBuyer: function() {
			this.openModalName = '';
			let body = document.getElementsByTagName('body')[0];
			body.classList.remove('not-scroll');
		},
		openVisitPrev: function() {
			// if (this.modalParam.visitReportState === 'NONE') {
			// 	alert('저장 후 미리보기가 가능합니다.');
			// 	return false;
			// }
			// this.$session.set('userId', this.loginMember.userId);
			// let token = this.$apiClient.getApiToken();
			// window.open(CONST.API_SERVER + '/admin/visitReport.do' + '?seqNo=' + this.matchSeqNo + '&userId=' + token, 'visit_report');
			//this.openModalName = '';
		},
		openAgreementPrev: function() {
			//this.$session.set('userId', this.loginMember.userId);
			let token = this.$apiClient.getApiToken();
			// window.open(CONST.API_SERVER + '/admin/businessAgreeSubmit.do');

			let signFile = this.modalParam.signFile;
			if (signFile !== null) {
				window.open(
					CONST.API_SERVER + '/admin/print/myBusinessAgree.do' + '?matchSeqNo=' + this.matchSeqNo + '&userId=' + token,
					'buds_agreement_preview',
				);
			} else {
				window.alert('전자서명이미지를 첨부해주세요.');
				eventBus.$emit(CONST.EVENTS.CLOSE_MODAL);
				this.$device.pushView('/mypage');
			}
		},
		loadMemberInfo: function() {
			try {
				let dt = this.$device.loadLocalData('LOGIN_USER');
				if (dt) {
					this.loginMember = JSON.parse(dt);
					//this.$apiClient.setApiToken(this.loginMember.mobile_token);
				} else {
					this.loginMember = null;
					this.$device.pushView('/login');
				}
			} catch (e) {
				console.error(e);
			}
		},
		kcpAuth: function() {
			if (!this.$device.isMobile()) {
				let width = 410;
				let height = 500;
				let leftPos = screen.width / 2 - width / 2;
				let topPos = screen.height / 2 - height / 2;
				let winOpts = 'width=' + width + ', height=' + height + ', toolbar=no,status=no,statusbar=no,menubar=no,scrollbars=no,resizable=no';
				let position = ',left=' + leftPos + ', top=' + topPos;
				window.open('', 'auth_popup', winOpts + position);
			}
			this.$device.removeLocalData('AGREEMENT_AUTH_CD');
			this.$device.removeLocalData('AGREEMENT_AUTH_MSG');
			this.checkInt = window.setInterval(() => {
				let resCd = this.$device.loadLocalData('AGREEMENT_AUTH_CD');
				let resMsg = this.$device.loadLocalData('AGREEMENT_AUTH_MSG');
				if (resCd) {
					this.$device.removeLocalData('AGREEMENT_AUTH_CD');
					this.$device.removeLocalData('AGREEMENT_AUTH_MSG');
					if (resCd === '0000') {
						eventBus.$emit(CONST.EVENTS.SAVE_MODAL, this.openModalName, 'CONFIRM');
					} else if (resMsg !== '') {
						window.alert(resMsg);
					}
					window.clearInterval(this.checkInt);
				}
			}, 500);
			this.$refs.kcpAuthForm.target = 'auth_popup'; // !!주의 고정값 ( 리턴받을때 사용되는 타겟명입니다.)
			this.$refs.kcpAuthForm.action = this.$apiClient.getApiServer() + '/kcpAuthResult.do'; // 인증창 호출 및 결과값 리턴 페이지 주소
			this.$refs.kcpAuthForm.submit();
		},
		doAgreement: function() {
			let str = '협약서를 동의 하시겠습니까?';
			if (window.confirm(str)) {
				if (this.isCompany) {
					this.kcpAuth();
				} else {
					eventBus.$emit(CONST.EVENTS.SAVE_MODAL, this.openModalName, 'CONFIRM');
				}
			}
		},
	},
};
</script>

<style lang="css">
@import 'assets/css/app.css';
</style>
